<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-2 p-xl-5"
      >
        <b-col sm="8" md="6" lg="12" class="mb-5 px-xl-2 mx-auto">
          <div class="d-flex justify-content-center">
            <a href="/">
              <b-img class="mx-auto mb-2" height="90px" :src="logo" />
            </a>
          </div>
          <b-card-title
            style="width: fit-content"
            title-tag="h2"
            class="font-weight-bold mb-1 mx-auto"
          >
            تسجيل الدخول
          </b-card-title>
          <b-card-text class="mb-2 text-justify alert alert-danger p-1">
            يمكنك كمنظمة الوصول إلى حسابك من خلال تسجيل الدخول
            <b><u>باسم المستخدم وكلمة السر</u></b>
            الخاصة بك وفي حال كنت منظمة قيد التأسيس الرجاء تحديد خيار حساب قيد
            التأسيس من الأسفل
            <br />
            في حال لم تكون تملك كلمة سر واسم مستخدم الرجاء التواصل مع الوزارة.
          </b-card-text>

          <!-- form -->
          <validation-observer ref="loginValidation">
            <b-form class="auth-login-form mt-2" @submit.prevent>
              <!-- email -->
              <b-form-group label="اسم المستخدم" label-for="username">
                <validation-provider
                  #default="{ errors }"
                  mode="passive"
                  name="اسم المستخدم"
                  rules="required"
                >
                  <b-form-input
                    id="username"
                    v-model="username"
                    :state="errors.length > 0 ? false : null"
                    name="اسم المستخدم"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <label for="login-password">كلمة السر</label>

                <validation-provider
                  #default="{ errors }"
                  mode="passive"
                  name="كلمة السر"
                  rules="required|min:8"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false : null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">
                    {{ errors[0] }}
                  </small>
                </validation-provider>
              </b-form-group>

              <!-- checkbox -->
              <b-form-group>
                <div class="d-flex align-items-center">
                  <b-form-checkbox
                    id="remember-me"
                    v-model="temp"
                    name="checkbox-1"
                  >
                    حساب قيد التأسيس
                  </b-form-checkbox>
                  <feather-icon
                    v-b-tooltip.hover.v-secondary
                    title="املأ هذا الحقل في حال كان حسابك لمنظمة لديها طلب تأسيس قيد التدقيق من  قبل الوزارة"
                    size="16"
                    class="mx-25 mt-25"
                    icon="HelpCircleIcon"
                  ></feather-icon>
                </div>
              </b-form-group>

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                class="mt-2"
                :disabled="loading"
                @click="validationForm"
              >
                <b-spinner class="align-middle mx-1" v-if="loading" small />
                تسجيل الدخول
              </b-button>
            </b-form>
          </validation-observer>
          <div class="d-flex my-1 justify-content-between mt-3 mb-3">
            <b-link :to="{ name: 'ministry-login' }">
              <small>تسجيل الدخول بصفة وزارة</small>
            </b-link>
          </div>
          <div class="text-center">
            <hr />
            <small>النسخة 2.3.2 - 24.09.2024</small>
          </div>
        </b-col>
      </b-col>
      <!-- /Login-->

      <!-- Left Text-->
      <b-col lg="8" class="d-none p-0 d-lg-flex align-items-center">
        <!-- <div
          class="w-100 d-lg-flex align-items-center justify-content-center px-5 side-img"
        >
        </div> -->

        <b-carousel
          style="width: 100%; height: 100%"
          id="carousel-interval"
          no-hover-pause
          :interval="3500"
        >
          <b-carousel-slide
            v-for="(slide, index) in loginSliders"
            :key="index"
            :img-src="slide"
          />
        </b-carousel>
      </b-col>
      <!-- /Left Text-->
    </b-row>
    <div class="login_">
      <form-modal
        ref="passwordModalUserLogin"
        class=""
        :formSchema="passwordFormSchema"
        title="تغيير كلمة السر"
        v-model="modalPasswordMust"
        :loading="loadingPassword"
        @confirm="onModalConfirmedPassword"
        :BCansel="true"
      >
      </form-modal>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BCarousel,
  BCarouselSlide,
  BSpinner,
  VBTooltip,
} from "bootstrap-vue";
import FormModal from "@/components/FormModal.vue";

import { required, email, min } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { mapActions, mapGetters } from "vuex";
import AppFooter from "@/@core/layouts/components/AppFooter.vue";

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    ToastificationContent,
    ValidationProvider,
    ValidationObserver,
    BCarousel,
    BCarouselSlide,
    BSpinner,
    FormModal,
    AppFooter,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      temp: false,
      status: "",
      password: "",
      username: "",
      loginSliders: [],
      // validation rulesimport store from '@/store/index'
      logo: require("@/assets/images/logo/header-logo.png"),
      required,
      email,
      min,
      passwordFormSchema: {
        old_password: {
          component: "FormPassword",
          key: "old_password",
          attrs: {
            id: "old_password",
            label: " كلمة السر الخاصة بك",
            rules: "required|min:8",
          },
        },
        new_password: {
          component: "FormPassword",
          key: "new_password",
          attrs: {
            id: "new_password",
            label: " كلمة السر الجديدة ",
            rules: "required|min:8",
          },
        },
        new_password_confirmation: {
          component: "FormPassword",
          key: "new_password_confirmation",
          attrs: {
            id: "new_password_confirmation",
            label: "تأكيد كلمة السر ",
            rules: "required|min:8",
          },
        },
      },
    };
  },
  computed: {
    ...mapGetters("Auth", ["loading", "modalPasswordMust", "loadingPassword"]),
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
  },
  methods: {
    ...mapActions("Auth", ["login", "tempLogin", "sliders", "changePassword"]),
    async validationForm() {
      await this.$refs.loginValidation.validate().then(async (success) => {
        if (success) {
          if (this.temp) {
            await this.tempLogin({
              username: this.username,
              password: this.password,
            }).then(() => {
              this.$router.push({ name: "temp-ngo" });
            });
          } else {
            await this.login({
              username: this.username,
              password: this.password,
            }).then(() => {
              localStorage.setItem('fromLogin' , true)
            });
          }
        }
      });
    },
    async getSliders() {
      await this.sliders().then((result) => {
        this.loginSliders = result.data;
      });
    },
    onModalConfirmedPassword(form) {
      const toUpdate = {
        new_password: form.new_password,
        new_password_confirmation: form.new_password_confirmation,
        old_password: form.old_password,
      };
      this.changePassword(toUpdate);
    },
    onAddClickedPassword() {
      this.$refs.passwordModalUserLogin.init({});
      this.$store.dispatch("Auth/setModalPassword", true);
    },
  },
  beforeMount() {
    this.getSliders();
  },
  created() {
    this.$store.commit("appConfig/UPDATE_SKIN", "light");
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";

.login_ {
  #__BVID__97___BV_modal_header_ {
    button {
      display: none;
    }
  }
}

.side-img {
  background-size: cover;
}

.carousel-item {
  img {
    height: 93vh;
  }
}
</style>
